module.exports = __webpack_public_path__ + "static/media/vr.7a048951.gif";